import { Box, Typography, Container, Grid, Button, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';
import {
    Instagram,
    Facebook,
    YouTube
} from '@mui/icons-material';

// Language content configuration
const footerContent = {
    EN: {
        title: "Unicorn Beauty Business School",
        description: "Spread the wisdom of the beauty industry and redefine the beauty industry",
        contact: "Contact Us",
        address: "No.8 Wisma Unicorn, Petaling Utama Avenue, 46150 Petaling Jaya, Selangor",
        email: "darrensootba@gmail.com",
        phone: "+6016 267 7356",
        follow: "Follow Us",
        copyright: "© {year} Unicorn Beauty Business School. All rights reserved."
    },
    BM: {
        title: "Unicorn Beauty Business School",
        description: "Sebarkan kebijaksanaan industri kecantikan dan mendefinisikan ulang industri kecantikan",
        contact: "Hubungi Kami",
        address: "No.8 Wisma Unicorn, Petaling Utama Avenue, 46150 Petaling Jaya, Selangor",
        email: "darrensootba@gmail.com",
        phone: "+6016 267 7356",
        follow: "Ikuti Kami",
        copyright: "© {year} Unicorn Beauty Business School. Hak cipta dilindungi."
    },
    CN: {
        title: "独角兽美业商学院",
        description: "传播美业行业的智慧，重新定义美业行业",
        contact: "联系我们",
        address: "马来西亚雪兰莪州八打灵再也市Unicorn大厦8号",
        email: "darrensootba@gmail.com",
        phone: "+6016 267 7356",
        follow: "关注我们",
        copyright: "© {year} 独角兽美业商学院 版权所有"
    }
};

const Footer = ({ language = 'EN' }) => {
    const theme = useTheme();
    const hoverEffect = {
        whileHover: {
            scale: 1.1,
            transition: { duration: 0.3 }
        },
        whileTap: { scale: 0.95 }
    };

    const currentContent = footerContent[language] || footerContent.EN;
    const currentYear = new Date().getFullYear();

    const socialMedia = [
        {
            name: 'Instagram',
            icon: <Instagram />,
            url: 'https://www.instagram.com/unicornbeautybusinessschool/',
            color: '#E1306C'
        },
        {
            name: 'Facebook',
            icon: <Facebook />,
            url: 'https://www.facebook.com/UnicornBeautyBusinessSchool/',
            color: '#1877F2'
        },
        {
            name: 'YouTube',
            icon: <YouTube />,
            url: 'https://www.youtube.com/channel/UCXvHUnKmGXr4sWQ5Xp5V5JQ',
            color: '#FF0000'
        }
    ];

    return (
        <Box
            id="footer"
            component="footer"
            sx={{
                backgroundColor: '#2a2a2a',
                color: '#ffffff',
                py: 6,
                '& a': {
                    color: theme.palette.primary.light,
                }
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom>
                            {currentContent.title}
                        </Typography>
                        <Typography>
                            {currentContent.description}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom>
                            {currentContent.contact}
                        </Typography>
                        <Typography>
                            {currentContent.address}
                        </Typography>
                        <Typography>
                            {currentContent.email}
                        </Typography>
                        <Typography>
                            {currentContent.phone}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" gutterBottom>
                            {currentContent.follow}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {socialMedia.map((platform) => (
                                <IconButton
                                    key={platform.name}
                                    component={motion.a}
                                    href={platform.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    {...hoverEffect}
                                    sx={{
                                        backgroundColor: 'white',
                                        color: platform.color,
                                        '&:hover': {
                                            backgroundColor: 'white',
                                            opacity: 0.9
                                        }
                                    }}
                                >
                                    {platform.icon}
                                </IconButton>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
                <Typography
                    align="center"
                    sx={{ mt: 4 }}
                    component={motion.div}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                >
                    {currentContent.copyright.replace('{year}', currentYear)}
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;